module.exports = __webpack_public_path__ + "img/Carabaya.7763e26e.svg";